import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Home2 from '../views/Home2.vue'

// import { toTitleCase } from '@/utility'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home2,
  },
  {
    path: '/:product',
    name: 'Home',
    component: Home,
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

// router.afterEach((to) => {
//   // Use next tick to handle router history correctly
//   // see: https://github.com/vuejs/vue-router/issues/914#issuecomment-384477609
//   Vue.nextTick(() => {
//     if(to.params.product){
//       document.title = `RAND Boats - ${toTitleCase(to.params.product.replace("-", " "))}`
//       var meta = document.createElement('meta');
//       meta.name = "description";
//       meta.content = `Configure your ${toTitleCase(to.params.product.replace("-", " "))} today, and make it fit perfectly with your needs.`;
//       document.getElementsByTagName('head')[0].appendChild(meta);
//     }else{
//       document.title = "RAND Boats - Configurator"
//     }
//   });
// });

export default router
